module.exports = __webpack_public_path__ + "img/oops.bafc1177.png";